import i18n from 'i18next'
import { sendATCommand } from './command'
import { OnTerminalLog, Serial } from './serial'

export const deleteCertificates = async (
  session: Serial,
  onTerminalLog: OnTerminalLog,
): Promise<void> => {
  onTerminalLog(
    i18n.t(
      'device.calibration.preFlightStep.certificateUploadFlow.logs.checkingExistingCertificates',
    ),
  )
  await sendATCommand(session, 'AT+KCERTSTORE?', ['OK'])

  onTerminalLog(
    i18n.t(
      'device.calibration.preFlightStep.certificateUploadFlow.logs.removingExistingCertificates',
    ),
  )
  for (const command of [
    'AT+KCERTDELETE=0,0',
    'AT+KCERTDELETE=0,1',
    'AT+KCERTDELETE=0,2',
    'AT+KCERTDELETE=0,3',
    'AT+KCERTDELETE=1,0',
    'AT+KCERTDELETE=1,1',
    'AT+KCERTDELETE=1,2',
  ]) {
    await sendATCommand(session, command, ['OK'])
  }

  onTerminalLog(
    i18n.t(
      'device.calibration.preFlightStep.certificateUploadFlow.logs.verifyingCertificatesRemoved',
    ),
  )
  await sendATCommand(session, 'AT+KCERTSTORE?', [
    'OK',
    'root_cert,0,0',
    'root_cert,1,0',
    'root_cert,2,0',
    'root_cert,3,0',
    'local_cert,0,0',
    'local_cert,1,0',
    'local_cert,2,0',
  ])
}

export const storeCertificate = async (
  session: Serial,
  certificateBytes: Uint8Array,
  onTerminalLog: OnTerminalLog,
) => {
  onTerminalLog(
    i18n.t(
      'device.calibration.preFlightStep.certificateUploadFlow.logs.allocatingRootCertificateSpace',
    ),
  )
  await sendATCommand(
    session,
    `AT+KCERTSTORE=0,${certificateBytes.byteLength},0`,
    ['CONNECT'],
  )

  onTerminalLog(
    i18n.t(
      'device.calibration.preFlightStep.certificateUploadFlow.logs.sendingRootCertificatePayload',
      { bytes: certificateBytes.byteLength },
    ),
  )
  await session.writeRaw(certificateBytes)
  const response = await session.readUntilOutput()
  if (!response.includes('OK')) {
    throw new Error(
      i18n.t(
        'device.calibration.preFlightStep.certificateUploadFlow.errors.certificateWriteFailed',
      ),
    )
  }

  onTerminalLog(
    i18n.t(
      'device.calibration.preFlightStep.certificateUploadFlow.logs.verifyingRootCertificateAdded',
    ),
  )
  await sendATCommand(session, 'AT+KCERTSTORE?', [
    'OK',
    `root_cert,0,${certificateBytes.byteLength}`,
    new TextDecoder().decode(certificateBytes).trim(),
    'root_cert,1,0',
    'root_cert,2,0',
    'root_cert,3,0',
    'local_cert,0,0',
    'local_cert,1,0',
    'local_cert,2,0',
  ])
}
